// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/travel'

const state = {
  isBeforeApplResultYn: false
}

const mutations = {
  setBeforeApplResultYn (state, payload) {
    state.isBeforeApplResultYn = payload
  }
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 여행지원서 > 질문 리스트 > 여행지원서 질문 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelQuesList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travels`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 질문별 답변 리스트 > 여행지원서 질문별 답변 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelReplyList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-replies`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 타입별 시작번호 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getStartNumberByTypeList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-snumbers`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 질문별 답변 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setTravelReplyRegist ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/travel-replies`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 사용자별 진행 단계 > 사용자별 진행 단계 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getProgressStep ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-progress`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 진행 단계 데이터 > 진행단계 데이터 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getStepLoadData ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-progress/data`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 진행 단계 데이터 > 여행지원서 질문 답변 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelReplyNo ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-replies/number`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 진행 단계 데이터 > 여행지원서 질문 답변 번호 조회 API
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelReplyNoForUnikey ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-replies/unikey`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 진행 단계 데이터 > 여행지원서 감정 리스트 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelEmotionList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-emotions`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 감정 선택 리스트 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelEmotionChoiceList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-thermometer`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 Step 회차 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMemberStepCnt ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-step/cnt`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 감정 온도계 리스트 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelThermometerChoiceList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-thermometer/value`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 결과 리스트 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getApplResultList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 마음 날씨 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setApplResultMindWeather ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/travel-weather`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 마음날씨 구분 값 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getApplResultForWeatherStatus ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/weather-gubun`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 마음날씨 영역별 결과 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getApplResultForWeatherStat ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/weather-stat`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 마음나무 영역별 결과 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getApplResultForTreeStat ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/tree-stat`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 마음나무 결과 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getApplResultForTreeTotal ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/tree`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 감정상태 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getApplResultForEmotionValue ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/emotion`, payload)
  },

  /**
   * 사용자 > 여행가방 > 여행지원서 작성 횟수 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMemberApplResultCnt ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/cnt`, payload)
  },

  /**
   * 사용자 > 여행가방 > 여행지원서 작성 경과 개월 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMemberApplDiffMonth ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-diff/month`, payload)
  },

  /**
   * 사용자 > 여행가방 > 여행지원서 마지막 결과 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMemberApplResultLast ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/last`, payload)
  },

  /**
   * 사용자 > 여행지원서 삭제 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setMemberResultDel ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/delete`, payload)
  },

    /**
   * 사용자 > 여행가방 > 여행지원서 마지막 결과 조회 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getMemberApplResultFdb ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/fdb`, payload)
  },

    /**
   * 사용자 > 여행지원서 가이드 평가
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setGuideEval ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/guideEval`, payload)
  },
  /**
   * 사용자 > 여행지원서 결과 리스트 조회 api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async getTravelMemberHistoryList ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/travel-result/history`, payload)
  },

  /**
   * 사용자 > 여행지원서 > 여행지원서 마음 날씨 저장 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async setTrialApplResultMindWeather ({commit}, payload) {
    return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/trial/travel-weather`, payload)
  },
}

const getters = {
  isBeforeApplResultYn (state) {
    return state.isBeforeApplResultYn
  }
}
export default { state, mutations, actions, getters }
